import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Qualities, Quality} from '../../../../engine/playable/qualities';

const qualityTitles = {
  [Qualities.AUTO]: {title: 'Авто', letter: 'А'},
  [Qualities.SOURCE]: {title: 'Исходное', letter: 'И'},
  [Qualities.HIGH]: {title: 'Высокое', letter: 'В'},
  [Qualities.MEDIUM]: {title: 'Среднее', letter: 'С'},
  [Qualities.LOW]: {title: 'Мобильное', letter: 'М'},
};


@Component({
  selector: 'gg-quality-selector',
  templateUrl: './quality-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QualitySelectorComponent implements OnInit, OnChanges {
  @Input() qualities: Quality[];
  @Input() current: Quality;
  @Output() change = new EventEmitter<Quality>();

  public visible = false;
  public qualityTitles = qualityTitles;

  constructor() {
  }

  ngOnChanges() {
  }

  ngOnInit() {
  }

  toggleMenu() {
    this.visible = !this.visible;
  }

  setQuality(q) {
    this.change.emit(q);
  }


}
